<template>
    <v-text-field 
        :value="textValue"
        @change="change"
        @focus="$emit('focus', $event)"
        :label="schema.label" 
        :hint="schema.hint" 
        :placeholder="schema.placeholder || ' '"
        outlined dense hide-details
        prefix="$"
    />
        <!-- :hide-details="Boolean(schema.compact)"  -->
</template>

<script>

import NumberHelpers from '@/helpers/NumberHelpers'
import StringHelpers from '../../helpers/StringHelpers'

export default {

    data() {
        return { 

        }
    },

    components: {
        
    },
    
    props: {
        value: Object,
        schema: Object,
    },

    computed: {
        textValue() {
            return StringHelpers.formatNumber(this.value[this.schema.name])
        }
    },

    methods: {
        change(newVal) {
            newVal = this.convertToRawNumber(newVal)
            this.$emit('change', newVal)
        },

        convertToRawNumber(val) {
            if(val == '')
                return ''

            val = val.toLowerCase()

            let multiplier = 1

            if(val.indexOf('m') > -1)
                multiplier = 1000000
            else if(val.indexOf('k') > -1)
                multiplier = 1000

            val = NumberHelpers.numbersFromString(val)

            if(!val)
                val = 0

            val = val * multiplier

            return val
        },        

    },

    created() {

    },

    watch: {

    }

}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// CurrencyControl.vue?3d37e94a